import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NotificationDataService from "../../services/NotificationDataService";
import toast from "react-hot-toast";

// Thunk pour l'envoi de notif push
export const sendPushNotification = createAsyncThunk(
  "notifications/sendPushNotification",
  async (data, { rejectWithValue }) => {
    try {
      const response = await NotificationDataService.sendPushNotification(data);
      toast.success("Notification envoyée avec succès");
      return response.data;
    } catch (err) {
      toast.error("Erreur lors de l'envoi de la notification");
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    loadingPush: false,
    errorPush: null,
    successPush: false,
  },
  reducers: {
    resetNotificationState: (state) => {
      state.loadingPush = false;
      state.errorPush = null;
      state.successPush = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendPushNotification.pending, (state) => {
        state.loadingPush = true;
        state.successPush = false;
        state.errorPush = null;
      })
      .addCase(sendPushNotification.fulfilled, (state) => {
        state.loadingPush = false;
        state.successPush = true;
      })
      .addCase(sendPushNotification.rejected, (state, action) => {
        state.loadingPush = false;
        state.errorPush = action.payload;
        state.successPush = false;
      });
  }
});

export const { resetNotificationState } = notificationSlice.actions;
export default notificationSlice.reducer;
